import { useMemo } from 'react';

import { IconAppConnect } from '@components/icons/app-connect';
import { IconStatisticsBar } from '@components/icons/icon-statistics-bar';
import { IconInfo } from '@components/icons/info';
import { IconJobboard } from '@components/icons/jobboard';
import { IconList } from '@components/icons/list';
import { IconStages } from '@components/icons/stages';
import { IconTeam } from '@components/icons/team';
import { useIsMobile } from '@hooks/use-is-mobile';

import { usePermissions } from 'features/permissions';
import { useStore } from 'models/Provider';

export const useJobTabs = (job) => {
  const { t } = useStore();
  const isMobile = useIsMobile();
  const { hasRolePermission } = usePermissions();

  return useMemo(() => {
    if (isMobile) {
      return [
        {
          display: t('job.tabs.pipeline'),
          value: 'pipeline',
          link: job.pipelineUrl,
          icon: <IconStages />,
        },
        {
          display: t('job.tabs.applicants'),
          value: 'list',
          link: job.applicantsUrl,
          icon: <IconList />,
        },
        hasRolePermission('job:statistics') && {
          display: t('job.tabs.statistics'),
          value: 'statistics',
          link: job.statisticsUrl,
          icon: <IconStatisticsBar />,
        },
      ].filter(Boolean);
    }
    return [
      {
        display: t('job.tabs.pipeline'),
        value: 'pipeline',
        link: job.pipelineUrl,
        icon: <IconStages />,
      },
      {
        display: t('job.tabs.applicants'),
        value: 'list',
        link: job.applicantsUrl,
        icon: <IconList />,
      },
      { display: t('job.tabs.info'), value: 'info', link: job.jobInfoUrl, icon: <IconInfo /> },
      hasRolePermission('job:access') && {
        display: t('job.tabs.access'),
        value: 'access',
        link: job.accessUrl,
        icon: <IconTeam />,
      },
      hasRolePermission('job:statistics') && {
        display: t('job.tabs.statistics'),
        value: 'statistics',
        link: job.statisticsUrl,
        icon: <IconStatisticsBar />,
      },
      hasRolePermission('job:apps') && {
        display: t('job.tabs.integrations'),
        value: 'integrations',
        link: job.integrationsUrl,
        icon: <IconAppConnect />,
      },
      hasRolePermission('job:promote') && {
        display: t('job.tabs.promote'),
        value: 'promote',
        link: job.promoteUrl,
        icon: <IconJobboard />,
      },
    ].filter(Boolean);
  }, [t, job, isMobile, hasRolePermission]);
};
